import MicroModal from 'micromodal';
import PanZoom from 'panzoom';

export namespace ZoomImage {

	let setupZoom = () => {
		let zoomImages = document.querySelectorAll('.js-zoom-image');

		zoomImages.forEach((zoomImage) => {

			zoomImage.addEventListener('click', (e) => {
				e.preventDefault();

				MicroModal.show('modal-zoom-image', {
					onShow: function(){
						let panzoomImage:HTMLElement = document.querySelector('.js-panzoom-image');
						PanZoom(panzoomImage, {
							maxZoom: 2
						});
					}
				});
			});
		});
	}

	export const init = () => {
		setupZoom();
	}
}

document.addEventListener('DOMContentLoaded', ZoomImage.init);
